import {Type} from 'main.core';
import {Node} from 'landing.node';

export class Map extends Node
{
	constructor()
	{
		super();
	}

	setName()
	{

	}
}